/*
*  开发与发布环境配置
*  @params dev {Boolean} 判别环境
*  @params BASE_PATH {String} 发布环境静态资源根路径
*  @params API_PATH {String} 发布环境接口根路径
*  @params ASSET_PATH {String} Code Context中的资源根路径
*  @params MOCK_PATH {String} Code Context中的接口根路径
* */

const proConfig = require('../../../config')

const prostatus = process.env.NODE_ENV
console.log(process.env, '环境变量');
const DEV = prostatus === 'development';
const [BASE_PATH,
  BUILD_API_PATH,
  PRO_API_PATH,
  ACTIVE_PATH,
  DEV_API_PATH,
  devApiV2,
  BUILD_APIV2_PATH,
  PRO_APIV2_PATH,
  devWebUrl,
  proWebUrl,
  devOriginUrl,
  proOriginUrl,
  shenceUrl,
  luckDrawUrl,
  luckDrawUrlOut,
  paymentUrl,
  paymentUrlOut,
  activityUrlDev,
  activityUrlPro,
  sandBoxApi,
  sandBoxApiV2,
  sandBoxLuckDrawApi,
  beeAppUrlApi,
  beeAppUrlOutApi,
  luckDrawApiNewPoint,
  luckDrawApiNewPointOut
] = [proConfig.basePath,
  proConfig.buildApi,
  proConfig.proApi,
  proConfig.activeApi,
  proConfig.devApi,
  proConfig.devApiV2,
  proConfig.buildApiV2,
  proConfig.proApiV2,
  proConfig.devWebUrl,
  proConfig.proWebUrl,
  proConfig.devOriginUrl,
  proConfig.proOriginUrl,
  proConfig.shenceUrl,
  proConfig.luckDrawApi,
  proConfig.luckDrawApiOut,
  proConfig.paymentUrl,
  proConfig.paymentUrlOut,
  proConfig.activityUrlDev,
  proConfig.activityUrlPro,
  proConfig.sandBoxApi,
  proConfig.sandBoxApiV2,
  proConfig.sandBoxLuckDrawApi,
  proConfig.beeAppUrlApi,
  proConfig.beeAppUrlOutApi,
  proConfig.luckDrawApiNewPoint,
  proConfig.luckDrawApiNewPointOut
];
const ASSET_PATH = DEV ? '' : BASE_PATH;
const ACTIVE_MOCK_PATH = DEV ? '/api' : ACTIVE_PATH;
const SHARE_PATH = PRO_API_PATH;
let MOCK_PATH = '';
const mockPathsV2 = [
  "/webApiV2",
  BUILD_APIV2_PATH,
  PRO_APIV2_PATH,
  sandBoxApiV2
];
let MOCK_PATH_V2 = '';
let LUCK_DRAW_PATH = '';
let ProWebUrl = '';
let OriginWebUrl = '';
let ActivityUrl = '';
let CUR_SHENCE_URL = '';
let WX_PAYMENT_URL = '';
let BEE_APPROVE_PATH = '';
let LUCK_DRAW_PATH_NEWPOINT = '';
if (DEV) { // 本地开发
  MOCK_PATH = '/api';
  MOCK_PATH_V2 = mockPathsV2[0];
  LUCK_DRAW_PATH = '/luck';
  ProWebUrl = devWebUrl;
  OriginWebUrl = devOriginUrl;
  ActivityUrl = activityUrlDev;
  CUR_SHENCE_URL = shenceUrl + '?project=default';
  WX_PAYMENT_URL = paymentUrl;
  BEE_APPROVE_PATH = '/bee';
  LUCK_DRAW_PATH_NEWPOINT = '/newLuckPoint';
} else {
  if (process.env.IS_PRO) { // 外网请求地址
    MOCK_PATH = PRO_API_PATH;
    MOCK_PATH_V2 = mockPathsV2[2];
    LUCK_DRAW_PATH = luckDrawUrlOut;
    ProWebUrl = proWebUrl;
    OriginWebUrl = proOriginUrl;
    ActivityUrl = activityUrlPro;
    CUR_SHENCE_URL = shenceUrl + '?project=production';
    WX_PAYMENT_URL = paymentUrlOut;
    BEE_APPROVE_PATH = beeAppUrlOutApi;
    LUCK_DRAW_PATH_NEWPOINT = luckDrawApiNewPointOut;
  } else {
    // 内网请求地址
    ProWebUrl = devWebUrl;
    OriginWebUrl = devOriginUrl;
    ActivityUrl = activityUrlDev;
    CUR_SHENCE_URL = shenceUrl + '?project=default';
    WX_PAYMENT_URL = paymentUrl;
    BEE_APPROVE_PATH = beeAppUrlApi;
    LUCK_DRAW_PATH_NEWPOINT = luckDrawApiNewPoint;
    MOCK_PATH = BUILD_API_PATH;
    MOCK_PATH_V2 = mockPathsV2[1];
    LUCK_DRAW_PATH = luckDrawUrl;

    if (process.env.IS_SANDBOX) { // 沙盒环境
      MOCK_PATH = sandBoxApi;
      MOCK_PATH_V2 = mockPathsV2[3];
      LUCK_DRAW_PATH = sandBoxLuckDrawApi;
      LUCK_DRAW_PATH_NEWPOINT = sandBoxLuckDrawApi;
    }
  }
}

export {
  LUCK_DRAW_PATH_NEWPOINT,
  DEV_API_PATH,
  ASSET_PATH,
  MOCK_PATH,
  MOCK_PATH_V2,
  ACTIVE_MOCK_PATH,
  DEV,
  ProWebUrl,
  OriginWebUrl,
  CUR_SHENCE_URL,
  LUCK_DRAW_PATH,
  SHARE_PATH,
  WX_PAYMENT_URL,
  ActivityUrl,
  BEE_APPROVE_PATH
}



// WEBPACK FOOTER //
// ./src/starcharge/utils/dispatchEnv.js